import React from "react";

export function Main({ children }) {
  return (
    <div className="flex flex-col">
      <div className="rounded-md border-y border-gray-100 bg-white px-0">
        <div id="followups-swimlane-content" className="mt-2">
          {children && React.Children.map(children, (child) => React.cloneElement(child))}
        </div>
      </div>
    </div>
  );
}
